import { Component, OnInit , ViewChild ,TemplateRef } from '@angular/core';
import { OpportunityService } from 'src/app/Services/Opportunity/opportunity.service';
import { faThumbsUp, faThumbsDown, faTrash, faComment, faPlusCircle, faClosedCaptioning,faPencilAlt , faSlash } from '@fortawesome/free-solid-svg-icons';
import { CommentaireService } from 'src/app/Services/Commentaire/commentaire.service';
import { Opportunity } from 'src/app/Models/Opportunity';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators,NgModel } from '@angular/forms';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ToastService } from 'src/app/Services/toast/toast.service';
import { AlertService } from 'src/app/Services/User/alert.service';


@Component({
  selector: 'app-opportunities',
  templateUrl: './opportunities.component.html',
  styleUrls: ['./opportunities.component.scss']
})
export class OpportunitiesComponent implements OnInit {
 

 id:any ; 
 ListOpportunity:any ; 
 title:string;
 date:string; 
 user:string; 
 faThumbsUp = faThumbsUp;
 faThumbsDown = faThumbsDown;
faTrash = faTrash;
faPencilAlt=faPencilAlt;
faComment = faComment;
nComment: any;
nOpportunity:any ;
hideformopportunity = true;
Opportunity:any={};
selectedFile: File = null;
hideimage = true;

hideform = false;
showmsg = true;
msg = '';
closeResult: string;
faAdd=faPlusCircle;
style1: string;
isOpened: boolean;
toggleStyle: string;
faClose=faSlash;
isModalOpen = false;
form: FormGroup;
submitted = false;



 
constructor(private modelService: NgbModal,
  private opportunityService: OpportunityService,
  private router: Router,
  private formBuilder: FormBuilder,
  private alertService: AlertService,
  private commantairesService: CommentaireService,
  private toast:ToastService) {
 
}



  ngOnInit(): void {
    this.getAllOpportunties();
    this.hideSupp(this.id);
    this.hideUpp(this.id);
    this.hideFormopportunity();
    this.form = this.formBuilder.group({
     
        title: ['', Validators.required],
        description: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        numtlf: ['', [Validators.required, this.eightDigit.bind(this)]],
        image: ['', [Validators.required ]]// Added required and file type validation for the image field
 
     
    });

  }
  /*imageFileTypeValidator(control: AbstractControl): ValidationErrors | null {
    const file = control.value;
    if (file) {
      const allowedFileTypes = ['image/jpeg', 'image/png', 'image/gif']; // Add any other image file types you want to allow
      if (!allowedFileTypes.includes(file.type)) {
        return { invalidFileType: true };
      }
    }
    return null;
  }
  */

  eightDigit(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value && value.toString().length !== 8) {
      return { 'eightDigit': true };
    }
    return null;
  }
  
  
  get f() {
    return this.form.controls;
  }
  openModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'block';
  }

  closeModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'none';
  }
  

 
    onSubmit() {
      this.id = localStorage.getItem("Id") ; 
      this.submitted = true;
    
      // Stop here if the form is invalid
      if (this.form.invalid) {
        return;
      }
      const opportunity = {
        title: this.f.title.value,
        description: this.f.description.value,
        email: this.f.email.value,
        numtlf: this.f.numtlf.value
      };
   

      this.opportunityService.addOpportunity2(opportunity,this.id,this.selectedFile).subscribe(
        data=>{
          this.form.reset();
          console.log("opportunity added Succeffully ");
          this.toast.SuccessToast("Opportunity Added");
          this.router.navigate(['/home/opportunities']);
        },
        err=>{
          console.error('Error adding opportunity:', err);
          this.toast.ErrorToast("Opportunity not Added");
        }
      )
    
      // Submit the form data
      // ...
    
      // Close the modal or perform any other action
      this.closeModal();
    }
  

  toggle(){
    this.style1="flex";
    // this.style2="none";
    this.isOpened=true;
    this.toggleStyle="flex";
  }
  closeNote(){
    this.style1="none"
    this.isOpened=false;
  }
  openalert(contentalert) {
    this.modelService.open(contentalert, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  getAllOpportunties() {
    this.opportunityService.getallOpportunities().subscribe(
      data => {
        this.ListOpportunity = data;
        this.nOpportunity = this.ListOpportunity.length;
        return this.ListOpportunity;
      },
      err=>{
        console.log(err);
      }
    )
  }
  setOpportunityId(id: any) {
    sessionStorage.setItem("IdOpportunity", id);
  }
  deleteOpportunity() {
    this.opportunityService.deleteOpportunity(sessionStorage.getItem("IdOpportunity")).subscribe(
      data => {
        return data;
      }
    );
  }

  ArcheiveOpportunity(){
    this.opportunityService.masquerOpportunity(sessionStorage.getItem("IdOpportunity")).subscribe(
      data=>{
        this.toast.SuccessToast("Opportunity Archeived");
        return data; 

      }
    )
  }
/*
  updateOpportunity(opportunity:Opportunity , id:any){
    this.opportunityService.updateOpportunity(opportunity,this.id,).subscribe(
      data =>{
        this.msg ="Opportunity Updated Successfully!"
        this.showmsg = false; 
        opportunity = data ;
        return opportunity ;
      }
    )
  }

  */

  
  hideSupp(id: any) {
    if (id == localStorage.getItem("Id")) {
      return false
    } else {
      return true
    }
  }
  hideUpp(id: any) {
    if (id == localStorage.getItem("Id")) {
      return false
    } else {
      return true
    }
  }
  hideFormopportunity() {
    if (localStorage.length != 0) {
      this.hideformopportunity = false;
    }
  }
  
  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    console.log(this.selectedFile);
  }
  
  //scroll to top page
  topFunction() {
   
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  navigateToOpportunity() {
    this.router.navigate(['/home/opportunities/opportunity']);
  }
  



}



